import React, { createContext, useState } from 'react';

interface NotificationContextInterface {
  tab: string;
  visible: boolean;
  modalConvo: any;
  changeTab: (tab: string) => any;
  toggleNotification: () => void;
  closeNotification: () => void;
  showConvo: (val: any) => void;
}

// @ts-ignore
export const NotificationContext = createContext<NotificationContextInterface | null>();

interface TabProviderProps {
  children: React.ReactNode;
}

export const NotificationProvider = ({ children }: TabProviderProps) => {
  const [tab, setTab] = useState<string>('notification');
  const [visible, setVisible] = useState<boolean>(false);
  const [modalConvo, setModalConvo] = useState({
    visible: false,
    id: 0,
  });

  const toggleNotification = () => {
    setVisible(!visible);
  };

  const closeNotification = () => {
    setVisible(false);
  };

  const changeTab = (tabName) => {
    setTab(tabName);
  };

  const showConvo = (val) => {
    setModalConvo(val)
  };

  return (
    <NotificationContext.Provider value={{
      tab,
      visible,
      modalConvo,
      changeTab,
      toggleNotification,
      closeNotification,
      showConvo,
    }}
    >{children}
    </NotificationContext.Provider>
  );
};
